import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { SimpleDropDownElement } from 'components/simple-dropdown/index';
import { markAsStartVideoAction, unMarkAsStartVideoAction } from 'common/actions';
import { channelsSelector, getCurrentPageNumberSelector } from 'common/selectors';
import { isAdminUser } from 'utils';
import { urlChannelIdSelector } from '../selectors';
import { urlSortSelector } from 'common/selectors/router';
import { withRouter } from 'react-router-dom';

/**
 * @param {*[]} channels
 * @param {number} channelId
 * @param {*} video
 */
const isStartVideo = (channels, channelId, video) => {
  const channel = channels.find((channel) => channel.id === channelId);
  if (!channel) {
    return false;
  }
  return channel.startVideoId === video.id;
};

const MarkUnmarkAsStartVideoItem = ({ t, unMarkAsStartVideo, markAsStartVideo, isStart }) => {
  if (!isAdminUser()) {
    return false;
  }

  return isStart ? (
    <SimpleDropDownElement onClick={unMarkAsStartVideo} data-e2e="unmark-as-start-video">
      {t('unmark_channel_start_video')}
    </SimpleDropDownElement>
  ) : (
    <SimpleDropDownElement onClick={markAsStartVideo} data-e2e="mark-as-start-video">
      {t('mark_channel_start_video')}
    </SimpleDropDownElement>
  );
};

export const MarkUnmarkAsStartVideoItemDecorated = compose(
  withTranslation(),
  withRouter,
  connect(
    (state, props) => {
      const params = props.match && props.match.params;
      const channels = channelsSelector(state);
      const currentChannel = urlChannelIdSelector(params)(state);

      return {
        pageNumber: getCurrentPageNumberSelector(state, props.match),
        sort: urlSortSelector(state, props.match),
        isStart: isStartVideo(channels, currentChannel, props.video),
        t: props.t,
      };
    },
    (dispatch, props) => ({
      unMarkAsStartVideo: () => {
        const params = props.match.params;
        dispatch(unMarkAsStartVideoAction(props.video, params.channelId, params.pageNumber, params.sort));
      },
      markAsStartVideo: () => {
        const params = props.match.params;
        dispatch(markAsStartVideoAction(props.video, params.channelId, params.pageNumber, params.sort));
      },
    })
  )
)(MarkUnmarkAsStartVideoItem);

MarkUnmarkAsStartVideoItemDecorated.propTypes = {
  video: PropTypes.object.isRequired,
};
